/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    rounded: { type: 'variant', values: [ true ] },
    size: { type: 'variant', values: [ 'small' ] }
  },
  rules: [
    {
      if: { size: 'small' },
      tokens: { paddingBottom: 4, paddingTop: 4 }
    },
    { if: { rounded: true }, tokens: { borderRadius: 4 } }
  ],
  tokens: {
    background: '#f9f2dd',
    borderRadius: 0,
    color: '#394056',
    gap: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8
  }
}
export default theme
